export const CONTEXTUAL_FILTER_CONSTANTS = {
    nights_suffix: 'nights'
};
